import { useForm } from '@tanstack/react-form';
import { useUpdateGroupMutation } from './mutations/use-update-group.mutation';
import { UpdateGroupRequest } from '@/types/api/group/request';
import { GroupType } from '@/types/api/group';
import { UpdateGroupSchema } from '@/validators/group/update-group.schema';

export function useUpdateGroupForm(initialValues?: UpdateGroupRequest) {
  const mutation = useUpdateGroupMutation();

  return useForm<UpdateGroupRequest>({
    defaultValues: {
      groupName: initialValues?.groupName || '',
      organizationName: initialValues?.organizationName || '',
      groupType: initialValues?.groupType || GroupType.SchoolClass,
    },
    validators: { onSubmit: UpdateGroupSchema },
    onSubmit: async ({ value }) => await mutation.mutateAsync(value),
  });
}
